import { OpenFeature, TypedInMemoryProvider } from "@openfeature/web-sdk";
import * as Sentry from "@sentry/react";

export const DEFAULT_FEATURE_FLAGS = {
    stripeBilling: false,
    stripeSetupCheckout: false,
    stripeLegacyPaymentIntents: false,
    stripeWebhooks: false,
    studentGroups: false,
    studentGroupsUserView: false,
    orderSupportThreads: false,
    pushNotifications: false,
    tournamentAutomation: false,
};

// Backend flags arrive already evaluated (booleans) via `preferences.siteSettings.featureFlags`,
// so the frontend mirrors them into an OpenFeature TypedInMemoryProvider instead of resolving them
// itself. This still gives us the OpenFeature evaluation API (and Sentry hook) the backend uses.
const toFlagConfiguration = (flags) => Object.fromEntries(
    Object.entries(flags).map(([key, value]) => [
        key,
        {
            disabled: false,
            variants: { on: true, off: false },
            defaultVariant: value ? "on" : "off",
        },
    ]),
);

const provider = new TypedInMemoryProvider(toFlagConfiguration(DEFAULT_FEATURE_FLAGS));
OpenFeature.setProvider(provider);
OpenFeature.addHooks(new Sentry.OpenFeatureIntegrationHook());

export const updateFeatureFlags = (flags) => {
    void provider.putConfiguration(toFlagConfiguration(flags));
};

export const featureFlagClient = OpenFeature.getClient();
